import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { RotaErrorsResponse, } from '../../../../interfaces/response/RotaResponses';
import { RotaErrors, StoreError, StoreWarning } from '../../../models/rota/RotaErrors';

@Injectable({
  providedIn: 'root'
})
export class RotaErrorsAdapter implements Adapter<RotaErrors> {

  /**
   * Converts rota errors HTTP response to {@link RotaErrors}.
   * @param item rota errors HTTP response.
   */
  adapt(item: RotaErrorsResponse): RotaErrors {
    if (!item) {
      return new RotaErrors([], []);
    }
    return new RotaErrors(
      item.errors.map(storeError => new StoreError(storeError.type, storeError.reason)),
      item.warnings.map(storeWarning => new StoreWarning(storeWarning.type, storeWarning.reason))
    );
  }
}
